import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <footer class="footer footer-center p-10  text-white">
      <div>
        <img
          className="w-[20%] block mx-[89px]"
          src="https://i.ibb.co/31Mkm6X/rsz-newword-removebg-preview.png"
          alt=""
        />
        <p class="font-bold text-2xl">
          Living , Learning ,Coding and Leveling Up <br /> one day at a time
        </p>
        <p className="font-semibold font-serif">
          Copyright © 2022 - All right reserved
        </p>
        <p className="font-semibold font-serif">
          Designed and Developed by me © Rafid
        </p>
        <p>Made with React js </p>
      </div>
      <div></div>
    </footer>
  );
};

export default Footer;
